import { defineNuxtPlugin } from '#app';
import { useCrossDomainTracking } from '~/composables/useCrossDomainTracking';

export default defineNuxtPlugin(() => {
	const { getTrackingData } = useCrossDomainTracking();

	// Initialize tracking data when the plugin is loaded
	getTrackingData();

	// Set up an interval to check for updates (every 5 minutes)
	const interval = setInterval(() => {
		getTrackingData();
	}, 5 * 60 * 1000);

	// Clean up interval when the plugin is unloaded
	return {
		provide: {
			cleanup: () => clearInterval(interval),
		},
	};
}); 